/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import styled from "styled-components";
import { Button, Dropdown, FlexContainer, Text, theme } from "@nordcloud/gnui";
import { Option, SortDirection } from "./types";

type Props = {
  options: Option[];
  value: string;
  direction: SortDirection;
  onSelect: (filter: string) => void;
  onSortChange: (direction: SortDirection) => void;
  disabled?: boolean;
};

const StyledDropdown = styled.div`
  position: relative;

  & > button {
    position: absolute;
    right: calc(${theme.spacing.spacing01} + 1px);
    top: calc(${theme.spacing.spacing01} + 1px);
  }
`;

export function SortSelector({
  options,
  value,
  direction,
  onSelect,
  onSortChange,
  disabled = false,
}: Props) {
  const isAscending = direction === SortDirection.Ascending;

  return (
    <FlexContainer>
      <Text nowrap tag="div" mr={theme.spacing.spacing04}>
        Sort by:
      </Text>
      <StyledDropdown>
        <Dropdown
          data-testid="sort-dropdown"
          name="Select"
          options={options}
          value={value}
          width="15rem"
          disabled={disabled}
          onChange={onSelect}
        />
        <Button
          data-testid="sort-button"
          size="md"
          severity="low"
          icon={isAscending ? "sortAscending" : "sortDescending"}
          type="button"
          onClick={() =>
            onSortChange(
              isAscending ? SortDirection.Descending : SortDirection.Ascending
            )
          }
        />
      </StyledDropdown>
    </FlexContainer>
  );
}
